<template>
  <table-component
    ref="weekTable"
    :data="data"
    :show-caption="false"
    class="datatable"
    sort-by="id"
    sort-order="asc"
    :show-filter="false"
  >
    <table-column show="id" label="Id" :hidden="true"></table-column>
    <table-column
      show="type"
      :label="$t('health.nutritionalPlan.meal')"
      header-class="text-left"
      cell-class="table-component__text-left"/>
    <table-column
      :label="$t('health.nutritionalPlan.weekDays.monday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
          <v-select
            :disabled="false"
            :searchable="false"
            :options="colorOptions"
            v-model="row.monday"
            v-on:input="changeRow(row)"
            v-bind:style="{ background: selectedColor(row.monday)}"
            class="text-black"
            dense>
          </v-select>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.tuesday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <v-select
          :disabled="false"
          :searchable="false"
          :options="colorOptions"
          v-model="row.tuesday"
          v-on:input="changeRow(row)"
          v-bind:style="{ background: selectedColor(row.tuesday) }"
          dense>
        </v-select>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.wednesday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <v-select
          :disabled="false"
          :searchable="false"
          :options="colorOptions"
          v-model="row.wednesday"
          v-on:input="changeRow(row)"
          v-bind:style="{ background: selectedColor(row.wednesday) }"
          dense>
        </v-select>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.thursday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <v-select
          :disabled="false"
          :searchable="false"
          :options="colorOptions"
          v-model="row.thursday"
          v-on:input="changeRow(row)"
          v-bind:style="{ background: selectedColor(row.thursday) }"
          dense>
        </v-select>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.friday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <v-select
          :disabled="false"
          :searchable="false"
          :options="colorOptions"
          v-model="row.friday"
          v-on:input="changeRow(row)"
          v-bind:style="{ background: selectedColor(row.friday) }"
          dense>
        </v-select>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.saturday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <v-select
          :disabled="false"
          :searchable="false"
          :options="colorOptions"
          v-model="row.saturday"
          v-on:input="changeRow(row)"
          v-bind:style="{ background: selectedColor(row.saturday) }"
          dense>
        </v-select>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.sunday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <v-select
          :disabled="false"
          :searchable="false"
          :options="colorOptions"
          v-model="row.sunday"
          v-on:input="changeRow(row)"
          v-bind:style="{ background: selectedColor(row.sunday) }"
          dense>
        </v-select>
      </template>
    </table-column>

  </table-component>
</template>

<script>
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableRow from '@/components/shared/table/components/TableRow';
import TableColumn from '@/components/shared/table/components/TableColumn';
import vSelect from 'vue-select';

export default {
  name: 'WeekPlanEditorTable',
  components: {
    TableRow,
    TableComponent,
    TableColumn,
    vSelect
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      items: [],
      colorOptions: [
        {label: this.$t('health.nutritionalPlan.colors.white'), value: 0, id: 0, color: 'rgba(169,152,152,0.32)'},
        {label: this.$t('health.nutritionalPlan.colors.green'), value: 1, id: 1, color: '#4e9d26'},
        {label: this.$t('health.nutritionalPlan.colors.yellow'), value: 2, id: 2, color: '#fcca2d'},
        {label: this.$t('health.nutritionalPlan.colors.red'), value: 3, id: 3, color: '#ff4f4f'},
        {label: this.$t('health.nutritionalPlan.colors.purple'), value: 4, id: 4, color: '#A853F8FF'}
      ]
    };
  },
  watch: {
    data: {
      handler: function () {
        this.data.forEach(value => {
          value.monday = this.colorOptions[value.monday];
          value.tuesday = this.colorOptions[value.tuesday];
          value.wednesday = this.colorOptions[value.wednesday];
          value.thursday = this.colorOptions[value.thursday];
          value.friday = this.colorOptions[value.friday];
          value.saturday = this.colorOptions[value.saturday];
          value.sunday = this.colorOptions[value.sunday];
        });
        this.items = this.data;
        this.$refs.weekTable.refresh();
      }
    }
  },
  methods: {
    selectedColor (selected) {
      let color = this.colorOptions[0].color;
      if (selected) {
        const data = this.colorOptions.find(data => data.id === selected.id);
        if (data) {
          color = data.color;
        }
      }
      return color;
    },
    changeRow (row) {
      const filtered = this.items.filter(item => item.id !== row.id);
      filtered.push(row);
      this.items = filtered;
      this.$emit('update', filtered);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/WeekPlanEditorTable.vue